import { render } from "./EditaRegra.vue?vue&type=template&id=868aa5f2&scoped=true"
import script from "./EditaRegra.vue?vue&type=script&lang=js"
export * from "./EditaRegra.vue?vue&type=script&lang=js"

import "./EditaRegra.vue?vue&type=style&index=0&id=868aa5f2&lang=scss&scoped=true"

import exportComponent from "D:\\Projetos\\Git\\MINUS\\Sites\\site-gerencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-868aa5f2"]])

export default __exports__